import { MapResponse } from '@/models/map'

const PADDING = 3

export function getMapPadding(data: MapResponse['result']): number {
  if (typeof data.backgroundUrl === 'string') {
    // disable padding for custom maps
    return 0
  }

  return PADDING
}
